interface SkeletonProps {
  /** Number of placeholder rows to render. Default 3. */
  rows?: number;
  /** Optional class on the outer wrapper. */
  className?: string;
  /** Accessible label announced by SR. Default "Loading…". */
  ariaLabel?: string;
  /** Variant. "list" = row-shaped (avatar + text). "text" = text-only bars. */
  variant?: 'list' | 'text';
}

/**
 * Generic shimmer-skeleton placeholder for list-shaped or text-shaped
 * loading states. Honors `prefers-reduced-motion` (CSS).
 */
export function Skeleton({
  rows = 3,
  className,
  ariaLabel = 'Loading…',
  variant = 'list',
}: SkeletonProps) {
  const indexes = Array.from({ length: rows }, (_, i) => i);
  return (
    <div
      className={`skeleton skeleton-${variant} ${className ?? ''}`}
      role="status"
      aria-label={ariaLabel}
      aria-busy="true"
    >
      {indexes.map((i) => (
        <div key={i} className={`skeleton-row skeleton-row-${variant}`} aria-hidden="true">
          {variant === 'list' && <span className="skeleton-avatar" />}
          <span className="skeleton-bar skeleton-bar-name" />
        </div>
      ))}
    </div>
  );
}
